import { Theme, css } from '@emotion/react';

import { Radius, Spacing, Typography } from 'chatie-design-system';

import { media } from '@styles/css';

import EFinderImage, {
  EFinderImageSizes,
} from '@components/common/EFinderImage';
import SvgIcon from '@components/common/SvgIcon';
import SwipeableListContainer from '@components/common/SwipableListContainer';

import ProfileImg from '@public/icons/profile_32.svg';

import { useGlobalContext } from '@contexts/global';
import { IChatCharacter } from '@model';

const gridContainerCSS = (rows: number) => css`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(${rows}, 1fr);
  column-gap: ${Spacing.xsmall}px;
  row-gap: 10px;
  padding: 6px 16px ${Spacing.large}px;
  margin-top: ${Spacing.medium}px;
  ${media.tablet} {
    padding: 6px ${Spacing.xlarge}px ${Spacing.large}px;
  }
  ${media.desktop} {
    padding: 6px ${Spacing.xxlarge}px ${Spacing.large}px;
  }
`;

const cardContainerCSS = (theme: Theme) => css`
  display: flex;
  flex: 1;
  width: 300px;
  padding: ${Spacing.small}px;
  border-radius: ${Radius.small}px;
  height: 74px;

  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);

  .imageContainer {
    width: 50px;
    height: 50px;
    border-radius: ${Radius.small}px;
    margin-right: ${Spacing.small}px;
    position: relative;
    overflow: hidden;
  }
  .image {
    width: 50px;
    height: 50px;
    background-color: ${theme.var.gray200};
    border-radius: ${Radius.small}px;
    margin-right: ${Spacing.small}px;
  }
  .infoContainer {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    overflow: hidden;
  }
  .name {
    ${Typography.body12};
  }
  .info {
    ${Typography.body11};
    color: ${theme.var.gray500};
    margin-top: ${Spacing.xxsmall}px;
    margin-bottom: ${Spacing.xsmall}px;
  }
  .desc {
    width: 100%;
    ${Typography.h6};
    font-size: 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

type CharacterPlacardListProps = {
  characters: IChatCharacter[];
  rowCount: number;

  onClickCard?: (id: number) => void;
  onClickProfile?: (id: number) => void;
};

const CharacterPlaCardList = ({
  characters,
  rowCount,
  onClickCard,
  onClickProfile,
}: CharacterPlacardListProps) => {
  const { isCheming } = useGlobalContext();
  return (
    <SwipeableListContainer className="galleryCardListContainer">
      <div className="gridContainer" css={gridContainerCSS(rowCount)}>
        {characters?.map((item, idx) => (
          <div
            css={cardContainerCSS}
            key={`info_list_${idx}`}
            onClick={() =>
              isCheming || item?.type === 'official'
                ? onClickProfile && onClickProfile(item.id)
                : onClickCard && onClickCard(item.id)
            }
          >
            <div className="imageContainer">
              {item.profile_image && item.profile_image.key ? (
                <EFinderImage
                  image={item.profile_image}
                  h={EFinderImageSizes.avatar}
                  alt={'profile_img'}
                />
              ) : (
                <div className="image">
                  <SvgIcon icon={ProfileImg} d={50} />
                </div>
              )}
            </div>
            <div className="infoContainer">
              <h6 className="name">{item.name}</h6>
              <p className="info">{`${
                item.information.age ? item.information.age : 'N'
              }세 | ${
                item.information.job ? item.information.job : '직업'
              }`}</p>
              <p className="desc">{item.greeting}</p>
            </div>
          </div>
        ))}
      </div>
    </SwipeableListContainer>
  );
};

export default CharacterPlaCardList;
